import type { TFunction } from 'i18next';
import { RepoValidationError } from '@/db/repo';
import { ApiError } from '@/lib/api';
import { OtherUserDataError, PartnerRecoveryRequiredError } from '@/auth/session';

/** G-11: error codes are translated, never shown raw. */
export function errorMessage(t: TFunction, e: unknown): string {
  if (e instanceof ApiError) {
    if (e.code === 'NETWORK') return t('errors.NETWORK');
    if (e.code === 'ACCOUNT_LOCKED') {
      const until = (e.details as { lockedUntil?: string } | undefined)?.lockedUntil;
      return t('errors.ACCOUNT_LOCKED_UNTIL', { time: until ? new Date(until).toLocaleTimeString() : '' });
    }
    return t(`errors.${e.code}`, { defaultValue: t('errors.UNKNOWN') });
  }
  if (e instanceof OtherUserDataError) return t('errors.OTHER_USER_DATA', { count: e.pending });
  if (e instanceof PartnerRecoveryRequiredError) return t('login.partnerRecovery');
  if (e instanceof RepoValidationError) return t('errors.VALIDATION_FAILED');
  return t('errors.UNKNOWN');
}
